<div id="map" #map></div>
<!-- <div class="mapZoomControlWrapper">
  <div class="group">
    <div class="button" (click)="zoomIn()"><img src="/assets/img/icons/zoom-in.svg"></div>
    <div class="button" (click)="zoomOut()"><img src="/assets/img/icons/zoom-out.svg"></div>
  </div>
  <div class="button group" (click)="resetZoom()"><img src="/assets/img/icons/zoom-reset.svg"></div>
</div> -->
<app-popup-grid class="popup"
  [stats]="popupData"
  [class.shown]="popupShown"
  [style.left.px]="popupLeft"
  [style.top.px]="popupTop">
</app-popup-grid>
